import { Grid, Typography, List, Rating } from "@mui/material";
import { brandingConstants } from "../../PreviewStyles/constants";
import { handleConvertPxToPt } from "../helpers";

const RateIcon = ({
  width = "25px",
  height = "25px",
  isEmpty,
  isSelectedColor = "#FFBC01",
  isEmptyColor = "#000000",
  technology,
}: {
  width?: string;
  height?: string;
  isEmpty?: boolean;
  isSelectedColor?: string;
  isEmptyColor?: string;
  technology?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 69 66"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M68.0703 24.7357C67.6251 23.3667 66.4109 22.3975 64.98 22.268L45.4638 20.4962L37.7508 2.43865C37.1814 1.11199 35.8857 0.255737 34.4434 0.255737C33.0012 0.255737 31.705 1.11199 31.1391 2.43865L23.4262 20.4962L3.90684 22.268C2.47598 22.4001 1.26434 23.3693 0.816613 24.7357C0.371467 26.1046 0.782569 27.6062 1.86474 28.5553L16.6175 41.4913L12.2676 60.6496C11.9494 62.0583 12.4961 63.5149 13.665 64.3598C14.2932 64.8163 15.0314 65.0443 15.7721 65.0443C16.4086 65.0443 17.0456 64.8751 17.6146 64.5347L34.4434 54.4722L51.2692 64.5347C52.5036 65.2723 54.0557 65.2047 55.2219 64.3598C56.3907 63.5149 56.9375 62.0583 56.6192 60.6496L52.2694 41.4913L67.0221 28.5553C68.1038 27.6062 68.5154 26.1077 68.0703 24.7357Z"
        fill={`${isEmpty ? "#000000" : "#FFBC01"}`}
      />
    </svg>
  );
};

interface IProps {
  product: any;
  previewAgent: boolean;
  branding: any;
  ClickedCat?: string;
}

const SecondPagePreview = ({
  product,
  previewAgent,
  branding,
  ClickedCat,
}: IProps) => {
  return (
    <Grid item xs={12} mt={previewAgent ? "60px" : "15px"}>
      <Typography
        sx={{
          mb: 0,
          mt: 3,
          color: branding?.[brandingConstants.inputLabelColor],
          fontWeight: branding?.[brandingConstants.inputLabelFontWeight],
          fontStyle: branding?.[brandingConstants.inputLabelFontStyle],
          fontFamily: branding?.[brandingConstants.inputLabelFontFamily],
          fontSize: handleConvertPxToPt(
            branding?.[brandingConstants.inputLabelFontSize],
            previewAgent
          ),
        }}
      >
        {ClickedCat && `${ClickedCat} :`}{" "}
        {product?.feedbackSettings?.ratingHeading}
      </Typography>
      <List className="tv-prev-ratingicnlist">
        <Rating
          name="read-only"
          className="tv-prev-ratingicons"
          value={3}
          readOnly
          sx={{
            "&.MuiRating-root": {
              "& span": {
                marginRight: previewAgent ? "8px" : "1px",
              },
            },
          }}
          icon={
            <RateIcon
              width={previewAgent ? "80px" : "20px"}
              height={previewAgent ? "80px" : "20px"}
              isSelectedColor={
                branding?.[brandingConstants.ratingStarColorSelected]
              }
            />
          }
          emptyIcon={
            <RateIcon
              isEmpty
              width={previewAgent ? "80px" : "20px"}
              height={previewAgent ? "80px" : "20px"}
              isEmptyColor={
                branding?.[brandingConstants.ratingStarColorUnselected]
              }
            />
          }
        />
      </List>
    </Grid>
  );
};

export default SecondPagePreview;
